import { useQuery } from "@tanstack/react-query";
import { getRentalAvailability } from "../../api";

/**
 * The available start date a property's running tenancy implies. Contract management owns it, so the
 * listing form shows it read-only rather than letting the user type one — see RentalListingForm.
 */
export const useRentalAvailability = ({
  propertyUid,
}: {
  propertyUid?: string;
}) => {
  const query = useQuery({
    queryKey: ["rental-availability", propertyUid],
    queryFn: () => getRentalAvailability({ propertyUid: propertyUid! }),
    enabled: !!propertyUid,
  });

  return { ...query, data: query.data?.data };
};
